
/* Protopia Ecosystem component */
export interface IDotProps {
    id: string
    radius: number
    length: number
    i: number
    height: number
    left: number
}
const Dot = (props: IDotProps): JSX.Element => {
    return <div 
        className='landing-figure-dot-container'
        style={{
            left: props.left,  
            top:  props.height - props.radius / 2,
        }}
    >
        <div className="mt-1 text-danger">

        </div>
    </div>
}
export default Dot